import { render, staticRenderFns } from "./RespondidasSelo.vue?vue&type=template&id=c4b883d0&scoped=true"
import script from "./RespondidasSelo.vue?vue&type=script&lang=js"
export * from "./RespondidasSelo.vue?vue&type=script&lang=js"
import style0 from "./RespondidasSelo.vue?vue&type=style&index=0&id=c4b883d0&prod&lang=css"
import style1 from "./RespondidasSelo.vue?vue&type=style&index=1&id=c4b883d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b883d0",
  null
  
)

export default component.exports